module.exports = __webpack_public_path__ + "img/49.fb685392.jpeg";